"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductHero2View = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const components_1 = require("./ProductHero2View/components");
const ProductHero2ViewLeft_1 = require("./ProductHero2View/ProductHero2ViewLeft");
const ProductHero2ViewRight_1 = require("./ProductHero2View/ProductHero2ViewRight");
function ProductHero2View(_a) {
    var { product, className } = _a, viewProps = __rest(_a, ["product", "className"]);
    const [selectedVariant] = (0, react_1.useState)(product.variants[0].id);
    const variant = product.variants.find((v) => v.id === selectedVariant);
    if (!variant) {
        return null;
    }
    const contactOnly = !variant.price;
    const available = !product.trackInventory || variant.inventory > 0;
    return ((0, jsx_runtime_1.jsxs)(components_1.Wrap, Object.assign({ className: className, templateColumns: "50% 50%" }, { children: [(0, jsx_runtime_1.jsx)(ProductHero2ViewLeft_1.ProductHero2ViewLeft, Object.assign({ product: product, contactOnly: contactOnly, available: available }, viewProps)), (0, jsx_runtime_1.jsx)(ProductHero2ViewRight_1.ProductHero2ViewRight, { product: product })] })));
}
exports.ProductHero2View = ProductHero2View;
